import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import LanguageVersionSelector from "./LanguageVersionSelector";
import EView from "@/cms/enums/EView";
import EViewType from "@/cms/enums/EViewType";
import EContentType from "@/cms/enums/EContentType";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import { orderBy } from "lodash";

const redirectUrl = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.META_DATA, viewType: EViewType.TEXT, name: "redirectUrl" }
    ],
    type: "find"
});

// DEFAULT
const outerNameDescriptionLanguageVersion = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
    ],
    type: "find"
});

const outerTextLanguageVersion = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[], type:'filter'|'find' = "find", name?:string, contentType:EContentType=EContentType.DEFAULT ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.OUTTER, viewType: EViewType.TEXT, contentType, name }
    ],
    type: type
});

const innerLanguageVersions = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => orderBy(LanguageVersionSelector<TLanguageVersionList[]|TLanguageVersionDetail[]|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.INNER, contentType: EContentType.DEFAULT }
    ],
    type: "filter"
}), ["order"], ["asc"]);

const innerLanguageVersion = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.INNER, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT }
    ],
    type: "find"
});

// MENU
const menuNameDescriptionLanguageVersion = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.MENU_ITEM },
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
    ],
    type: "find"
});

// MAIN PAGE
const mainPageItemNameDescriptionLanguageVersion = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.MAIN_PAGE_ITEM },
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
    ],
    type: "find"
});

// PAGE
const pageNameDescriptionLanguageVersion = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.PAGE },
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
    ],
    type: "find"
});

// CATEGORY
const categoryNameDescriptionLanguageVersion = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.CATEGORY },
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
    ],
    type: "find"
});


// SLIDER_ITEM
const sliderNameDescriptionLanguageVersion = ( payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.SLIDER_ITEM },
        { view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }
    ],
    type: "find"
});

// DEFAULT
const metaDataLanguageVersion = ( name:string, payload?:TLanguageVersionList[]|TLanguageVersionDetail[] ) => LanguageVersionSelector<TLanguageVersionList|TLanguageVersionDetail|undefined>({
    languageVersions: payload,
    filters: [
        { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: name }
    ],
    type: "find"
})?.value||"";

export {
    redirectUrl,
    outerNameDescriptionLanguageVersion,
    outerTextLanguageVersion,
    innerLanguageVersions,
    innerLanguageVersion,
    menuNameDescriptionLanguageVersion,
    mainPageItemNameDescriptionLanguageVersion,
    pageNameDescriptionLanguageVersion,
    categoryNameDescriptionLanguageVersion,
    metaDataLanguageVersion,
    sliderNameDescriptionLanguageVersion
}
